

















































import { defineComponent, PropType, ref } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import OlbIcon from '../../../icon';
import { useList, inputProps, useDisplayLabel } from '../../formUtils';
import { LabeledListItem } from '../../types';
import { closable } from '../../../../utils/MouseUtils';
import registerValidators from '../../rules';

registerValidators();
closable;

export default defineComponent({
	components: { ValidationProvider, OlbIcon },
	props: {
		...inputProps,
		options: {
			type: Array as PropType<LabeledListItem[]>,
			required: true,
		},
	},
	setup(props, { emit }) {
		const visible = ref(false);
		const { currentlySelectedOption, selectValue } = useList(props, emit);
		const { displayLabel } = useDisplayLabel(props);

		const select = (value: string, validate: (value: string) => void) => {
			selectValue(value);
			validate(value);
			visible.value = false;
		};

		const onClose = () => (visible.value = false);

		return {
			visible,
			currentlySelectedOption,
			selectValue,
			select,
			onClose,
			displayLabel,
		};
	},
});
